import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Invoice } from '../../../models/invoice';
import { Observable } from 'rxjs';
import {
    selectPaymentAmount,
    selectPaymentBusy,
    selectPaymentCreditCards,
    selectPaymentPayableInvoices,
    selectPaymentSelectedInvoiceIds
} from '../../../store/payment/payment.state';
import { CreditCard } from '../../../models/credit-card';
import { map } from 'rxjs/operators';
import { paymentToggleInvoice } from '../../../store/payment/payment.actions';
import { selectProfileCurrency } from 'src/app/store/profile/profile.state';
import { CreditCardDisplayComponent } from '../credit-card-display/credit-card-display.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatDivider } from '@angular/material/divider';
import { MatCheckbox } from '@angular/material/checkbox';
import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-make-payment',
    templateUrl: './make-payment.component.html',
    styleUrls: ['./make-payment.component.scss'],
    imports: [MatCheckbox, MatDivider, MatRadioGroup, MatRadioButton, CreditCardDisplayComponent, AsyncPipe, CurrencyPipe, DatePipe]
})
export class MakePaymentComponent implements OnInit {

    public invoices$: Observable<Invoice[]>;
    public creditNotes$: Observable<Invoice[]>;
    public creditCards$: Observable<CreditCard[]>;
    public busy$: Observable<boolean>;
    public selectedInvoiceIds$: Observable<string[]>;
    public amount$: Observable<number>;
    public currency$: Observable<string>;

    constructor(private store: Store<AppState>) {
        this.invoices$ = this.store.select(selectPaymentPayableInvoices).pipe(
            map(invoices => invoices.filter(i => i.outstanding > 0))
        );
        this.creditNotes$ = this.store.select(selectPaymentPayableInvoices).pipe(
            map(invoices => invoices.filter(i => i.outstanding < 0))
        );
        this.selectedInvoiceIds$ = this.store.select(selectPaymentSelectedInvoiceIds);
        this.creditCards$ = this.store.select(selectPaymentCreditCards);
        this.busy$ = this.store.select(selectPaymentBusy);
        this.amount$ = this.store.select(selectPaymentAmount);
        this.currency$ = this.store.select(selectProfileCurrency);
    }

    public isInvoiceSelected(id: string): Observable<boolean> {
        return this.selectedInvoiceIds$.pipe(
            map(invoices => invoices.indexOf(id) > -1)
        );
    }

    public toggleInvoice(invoiceId: string): void {
        this.store.dispatch(paymentToggleInvoice({ invoiceId }));
    }

    ngOnInit(): void {
    }

}
